<p-button
  variant="text"
  severity="contrast"
  label="Columns"
  [disabled]="isLoading || !fields?.length"
  (onClick)="columnPopover.toggle($event)"
>
  <svg-icon src="/assets/icons/general/columns.svg" />
</p-button>
<p-popover #columnPopover (onHide)="onMenuClose()" (onShow)="onMenuOpen()">
  <div class="w-80">
    <p class="p-2 !pr-12 font-semibold">
      Customise order and visibility of columns
    </p>

    <div class="mb-2 ml-1 mr-3">
      <ag1-list-search
        [keys]="['displayName', 'name']"
        [items]="fields"
        placeholder="Search Columns"
        (filteredItemEvent)="filteredFields = $event"
      />
    </div>

    <div
      class="hover:scrollbar-thumb-slate-600 scrollbar-thumb-slate-500 scrollbar-track-slate-100 grid max-h-64 grid-cols-1 overflow-y-auto px-1.5"
    >
      @for (
        field of filteredFields;
        track tableService().trackByField(index, field);
        let index = $index
      ) {
        <div class="mr-2 text-xs">
          <div class="flex items-center gap-3">
            <input
              type="text"
              [(ngModel)]="field.order"
              (change)="updateColumnOrder(field, field.order)"
              pattern="^\d+$"
              class="w-8 !border-transparent p-1 hover:!border-slate-300"
            />
            <label class="flex grow select-none items-center gap-2">
              @if (!isFieldCheckable(field)) {
                <svg-icon
                  class="text-text-common-disabled"
                  [pTooltip]="tooltipText()"
                  src="/assets/icons/general/system-feedback-locked.svg"
                />
              } @else {
                <input
                  type="checkbox"
                  [(ngModel)]="field.checked"
                  (ngModelChange)="updateColumnVisibility(field)"
                />
              }
              @if (field?.displayName) {
                {{ field?.displayName }}
              } @else {
                {{
                  $safeNavigationMigration(field?.name)
                    | humanize
                    | sentenceCase
                }}
              }
            </label>
          </div>
        </div>
      }
    </div>

    <div class="mt-2 flex justify-end gap-2">
      <p-button
        size="small"
        variant="text"
        severity="contrast"
        (click)="resetColumnSelection()"
        label="Reset Columns"
      />
      <p-button
        size="small"
        (click)="applyColumnSelection()"
        label="Apply Selection"
      />
    </div>

    <p-button
      variant="text"
      severity="contrast"
      size="small"
      pTooltip="Close"
      class="absolute right-1 top-2"
      (click)="closeColumnsPanel()"
    >
      <ng-template #icon>
        <svg-icon src="/assets/icons/general/close.svg" />
      </ng-template>
    </p-button>
  </div>
</p-popover>
